(function () {
  function setCookie(name, value,hours) {
    const d = new Date();
    d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      ";expires=" +
      d.toUTCString() +
      ";path=/;SameSite=Lax";
  }

  function getCookie(name) {
    const key = encodeURIComponent(name) + "=";
    const parts = document.cookie.split(";");

    for (let i = 0; i < parts.length; i++) {
      let c = parts[i].trim();
      if (c.indexOf(key) === 0) return decodeURIComponent(c.substring(key.length));
    }
    return "";
  }

  function pickFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function updateReviewCount() {
    const productId = "{{ product.id }}";
    if (!productId || productId === "") return;

    const allowed = [25, 50, 75, 100, 125, 150, 175, 200];

    const cookieName = "reviewCount_" + productId;
    let reviewCount = getCookie(cookieName);

    if (reviewCount === "" || allowed.indexOf(Number(reviewCount)) === -1) {
      reviewCount = String(pickFromList(allowed));
      setCookie(cookieName, reviewCount, 24 * 30); // 30 days
    }

    const elements = document.getElementsByClassName("reviewCount");
    for (let i = 0; i < elements.length; i++) {
      elements[i].textContent = reviewCount;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateReviewCount);
  } else {
    updateReviewCount();
  }
})();
